import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UserProvider } from '../../providers/user';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import {TeamappProvider} from "../../providers/teamapp";
import { Camera, CameraOptions } from '@ionic-native/camera';

/**
 * Generated class for the MarketplaceAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-marketplace-add',
  templateUrl: 'marketplace-add.html',
})
export class MarketplaceAddPage {
  maxImages: number = 6;

  title: string = 'Inserieren';
  marketplaceAddForm: FormGroup;
  frontImage: string = '';
  images: any = [];
  datasets: any;
  base64img: string = '';

  ptitle: string = '';
  description: string = '';
  price: string = '';
  status: string = '';
  category: string = '';
  location: string = '';

  constructor(public userProvider: UserProvider, public camera: Camera, private formBuilder: FormBuilder, public navCtrl: NavController, public navParams: NavParams, public teamappProvider: TeamappProvider) {
      if(this.navParams.get("title")) {
          this.title = this.navParams.get("title");
      }

      this.teamappProvider.http_request('action=get_datasets', 'marketplace', false, true).then(data => {
          this.datasets = data;
          console.log(data);
          this.marketplaceAddForm = this.formBuilder.group({
              ptitle: ['', Validators.required],
              description: ['', Validators.required],
              price: ['', Validators.required],
              status: ['', Validators.required],
              category: ['', Validators.required],
              location: [''],
          });
      });

  }

imageCapturedFront() {
    const options:CameraOptions={
        quality:70,
        destinationType:this.camera.DestinationType.DATA_URL,
        sourceType:this.camera.PictureSourceType.PHOTOLIBRARY,
        saveToPhotoAlbum:false,
        allowEdit: false
    }
    this.camera.getPicture(options).then((ImageData=>{
        this.base64img=ImageData;
        this.frontImage = this.base64img;
    }),error=>{
        console.log(error);
    })
}

imageCapturedGallery(){
    const options:CameraOptions={
        quality:70,
        destinationType:this.camera.DestinationType.DATA_URL,
        sourceType: this.camera.PictureSourceType.PHOTOLIBRARY,
        saveToPhotoAlbum:false,
        allowEdit: false
    }
    this.camera.getPicture(options).then((ImageData=>{
        this.base64img=ImageData;
        this.images.push(this.base64img);
    }),error=>{
        console.log(error);
    })
}

    cancelImage(image: string) {
      for(let i = 0; i<this.images.length; i++) {
          if(this.images[i] == image) {
              this.images.splice(i, 1);
          }
      }
    }

    addItem() {
        let dIMGString = '';

        for(let i = 0;i<this.images.length;i++) {
            dIMGString = dIMGString + '&otherimage['+i+']='+this.images[i];
        }

        this.teamappProvider.http_request('action=add_item'+dIMGString+'&mainimage='+this.frontImage+'&add_title='+this.ptitle+'&add_description='+this.description+'&add_price='+this.price+'&add_price='+this.price+'&add_status='+this.status+'&add_category='+this.category+'&add_location='+this.location, 'marketplace', false, true).then(data => {
            console.log(data);
            this.navCtrl.pop();
        });
    }

    formatNumber(e: any, separador: string = '.', decimais: number = 2) {
        let a:any = e.value.split('');
        let ns:string = '';
        a.forEach((c:any) => { if (!isNaN(c)) ns = ns + c; });
        ns = parseInt(ns).toString();
        if (ns.length < (decimais+1)) { ns = ('0'.repeat(decimais+1) + ns); ns = ns.slice((decimais+1)*-1); }
        let ans = ns.split('');
        let r = '';
        for (let i=0; i < ans.length; i++) if (i == ans.length - decimais) r = r + separador + ans[i]; else r = r + ans[i];
        e.value = r;
    }


  ionViewDidLoad() {
    console.log('ionViewDidLoad MarketplaceAddPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/marketplace-add/marketplace-add.ts